import { useSelector } from "react-redux";
import { useEffect } from "react";

function GlobalTitleSetter() {
  const currentConfig = useSelector((state) => state.configData);

  useEffect(() => {
    if (currentConfig) {
      document.title = window.RUNTIME_CONFIG.webTitle;
    }
  }, [currentConfig]);

  return null;
}

export default GlobalTitleSetter;
